import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-loading-section',
  template: `
    <div class="loading-section" [style.color]="color">
      <i class="fal fa-spinner fa-spin"></i>
    </div>
  `,
  styles: [
    `
      .loading-section {
        font-size: 50px;
        text-align: center;
        padding: 50px 0;
      }
    `,
  ],
})
export class LoadingSectionComponent {
  @Input() color = '#60c063'
}
